// How long a player's "hide for now" lasts before active news pops up again.
export const NEWS_SNOOZE_MS = 6 * 60 * 60 * 1000;

// ts is rewritten on every edit, so ts_created is what places a message in
// the timeline. Messages saved before ts_created existed only carry ts.
export function getMessagePostedTs(message) {
  return message.ts_created ?? message.ts ?? 0;
}

export function sortGameMessages(gameMessages) {
  return Object.values(gameMessages ?? {})
    .sort((a, b) => getMessagePostedTs(b) - getMessagePostedTs(a));
}

// Messages saved before the toggle existed have no active flag and stay
// quiet until a manager switches them on.
export function getActiveGameMessages(gameMessages) {
  return sortGameMessages(gameMessages).filter(m => m.active === true);
}

// ts_activated is restamped every time a manager switches an item on. Items
// that went active before it existed fall back to their posting time.
export function getMessageActivatedTs(message) {
  return message.ts_activated ?? getMessagePostedTs(message);
}

// When a player hid the news popup, and the activation stamp of each item it
// showed, is remembered per device. An item that is new to the player, or was
// switched off and on again since, carries a stamp that does not match, which
// lets it pop up right away instead of waiting out the snooze.
function dismissalKey(gameId, playerId) {
  return `newsDismissed_${gameId}_${playerId}`;
}

export function getNewsDismissal(gameId, playerId) {
  try {
    const saved = JSON.parse(localStorage.getItem(dismissalKey(gameId, playerId)));
    if (typeof saved?.ts !== 'number' || typeof saved.seen !== 'object' || !saved.seen) return null;
    return saved;
  } catch {
    return null;
  }
}

export function hasNewActivation(dismissal, activeMessages) {
  return activeMessages.some(m => dismissal.seen[m.id] !== getMessageActivatedTs(m));
}

export function setNewsDismissal(gameId, playerId, shownMessages) {
  const seen = {};
  for (let m of shownMessages) {
    seen[m.id] = getMessageActivatedTs(m);
  }
  try {
    localStorage.setItem(
      dismissalKey(gameId, playerId),
      JSON.stringify({ 'ts': Date.now(), 'seen': seen })
    );
  } catch {
    // storage unavailable: the popup will just show again next visit
  }
}
